import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type {
  CreativeVariantAction,
  CreativeVariantWarning,
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult,
} from "./types";

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult =
  objectOf({
    hits: number,
    results: arrayOf(
      objectOf({
        id: string,
        creative: string,
        compatibleBaseCreativeCampaignIds: arrayOf(string),
      })
    ),
  });

export const isCreativeVariantWarning = objectOf<CreativeVariantWarning>({
  type: (v: unknown): v is CreativeVariantWarning["type"] => v === "orphaned_variant",
  message: string,
});

export const isCreativeVariantAction = objectOf<CreativeVariantAction>({
  variantId: number,
  creative: string,
  compatibleBaseCreativeCampaignIds: arrayOf(string),
});

export const isPostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult =
  objectOf<PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult>({
    variant: isCreativeVariantAction,
    warnings: arrayOf(isCreativeVariantWarning),
  });
